import { HELP_CATEGORY_SLUGS } from '@repo/utils';
import z from '@/lib/zod';

export const helpSearchSchema = z.object({
  q: z.string().nullish(),
  category: z.enum(HELP_CATEGORY_SLUGS).nullish(),
});
